//constants
import {SIDEBAR, EVENT_ID} from '@/utils/constants';
//types
import {IOrganizationTableInfo} from '@/utils/types';
import {CreateEventFormValues} from './formConfiguration';
//service
import {orgStorage} from '@/utils/services/storage.service';
//enums
import {STORAGE_KEY} from '@/utils/enums';
//helpers
import {formatToUtsDateTime} from '@/utils/helpers';

export const createEventSteps = [
	`1. ${SIDEBAR.EVENT_SETTINGS}`,
	`2. ${SIDEBAR.TABLES_AND_TICKETS}`,
	`3. ${SIDEBAR.EVENT_WEBPAGE}`,
];

export enum CREATE_EVENT_STEP {
	SETTING,
	TABLES_AND_TICKETS,
	WEBPAGE,
}

export const getTableInfosEmptyField = (tableInfos: Omit<IOrganizationTableInfo, typeof EVENT_ID>[]) =>
	tableInfos.some(
		(info: Omit<IOrganizationTableInfo, typeof EVENT_ID>) =>
			!!info.tier || !!info.numberOfSeats || !!info.amount || !!info.price
	);

export const getNewEventValues = (eventValues: CreateEventFormValues, raffleImage: string) => {
	const organizationId = orgStorage.get(STORAGE_KEY.ORGANIZATION_ID) as number;

	const shouldSendRaffle = eventValues.isRaffle || eventValues.id;

	const {
		name,
		goalAmount,
		isGoalAmount,
		description,
		location,
		startDate,
		startTime,
		endDate,
		endTime,
		sponsors,
		tableInfos,
		ticketsSalesStartDate,
		ticketsSalesStartTime,
		ticketsSalesEndDate,
		ticketsSalesEndTime,
		customizeWebpage,
		primaryColor,
		isOnlineAuction,
		startAuctionDate,
		startAuctionTime,
		endAuctionDate,
		endAuctionTime,
		isFundTheMission,
		isRaffle,
		startRaffleDate,
		startRaffleTime,
		endRaffleDate,
		endRaffleTime,
		raffleDescription,
		quantity,
		raffleTires,
		logo,
		prizeLogo,
	} = eventValues;

	const startEventDate = formatToUtsDateTime(startDate, startTime);
	const endEventDate = formatToUtsDateTime(endDate, endTime);
	const ticketsSalesStart = formatToUtsDateTime(ticketsSalesStartDate, ticketsSalesStartTime);
	const ticketsSalesEnd = formatToUtsDateTime(ticketsSalesEndDate, ticketsSalesEndTime);
	const startAuctionData = formatToUtsDateTime(startAuctionDate, startAuctionTime);
	const endAuctionData = formatToUtsDateTime(endAuctionDate, endAuctionTime);
	const startRaffleData = formatToUtsDateTime(startRaffleDate, startRaffleTime);
	const endRaffleData = formatToUtsDateTime(endRaffleDate, endRaffleTime);

	const allSponsors = sponsors.map((sponsor) => ({
		name: sponsor.name,
		categoryId: +sponsor.categoryId,
		logo: typeof sponsor.logo === 'string' ? sponsor.logo.split('/')[4]?.split('?')[0] ?? '' : '',
	}));

	const imageForRaffle =
		raffleImage || (typeof prizeLogo === 'string' ? prizeLogo.split('/')[4]?.split('?')[0] : '') || '';

	const newEventsValues = {
		organizationId: +organizationId,
		name,
		goalAmount: goalAmount || 0,
		isGoalAmount,
		description,
		location,
		startData: startEventDate || '',
		endData: endEventDate || '',
		sponsors: allSponsors,
		tableInfos: tableInfos.map((info) => ({
			...info,
			fairMarketValue: info.fairMarketValue || null,
			remainingTicketsThresholdValue: info.remainingTicketsThresholdValue || null,
		})),
		ticketsSalesStart,
		ticketsSalesEnd,
		customizeWebpage,
		...(primaryColor && {primaryColor}),
		isOnlineAuction,
		...(isOnlineAuction && {
			startAuctionData,
			endAuctionData,
		}),
		isFundTheMission,
		image: typeof logo === 'string' ? logo.split('/')[4]?.split('?')[0] ?? '' : '',
		isRaffle,
		...(shouldSendRaffle && {
			raffleInfo: {
				raffleDescription: raffleDescription || '',
				startRaffleDate: startRaffleData || '',
				endRaffleDate: endRaffleData || '',
				generalQty: quantity || null,
				...(imageForRaffle && {raffleImage: imageForRaffle}),

				tickets:
					raffleTires.length > 0
						? raffleTires.map((tire) => ({qty: tire.numberOfTickets, price: +tire.price, id: tire.id}))
						: [],
			},
		}),
	};

	return newEventsValues;
};
